var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78822 2.57508C2.07231 3.05615 1.5284 3.75784 1.23702 4.5763C0.945647 5.39475 0.922291 6.28645 1.17041 7.11939C1.41853 7.95233 1.92494 8.68223 2.61467 9.20105C3.3044 9.71986 4.14078 10 5 10C5.85922 10 6.6956 9.71986 7.38533 9.20105C8.07506 8.68223 8.58147 7.95233 8.82959 7.11939C9.07771 6.28645 9.05435 5.39475 8.76298 4.5763C8.4716 3.75784 7.92769 3.05615 7.21178 2.57508M5.00022 1V4.60019",
    stroke: "#860000",
    strokeOpacity: 0.9,
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.723bb9755027b0ac4c59e5981c0599ac.svg";
export { ForwardRef as ReactComponent };